// https://stackoverflow.com/a/423385
export default function getFilenameFromPath(fullPath: string): string {
  /* eslint-disable no-useless-escape */
  return fullPath.replace(/^.*[\\\/]/, '')
}
